import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2517060f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-title fw-bold fs-3 mb-0" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "svg-icon svg-icon-1" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = {
  key: 0,
  class: "modal-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _directive_dialog_auto_focus = _resolveDirective("dialog-auto-focus")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.isDialogDisplay)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal-backdrop fade show base-modal-backdrop",
          style: _normalizeStyle({ zIndex: _ctx.backdropZIndex }),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onBackdropClick && _ctx.onBackdropClick(...args)))
        }, null, 4))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["modal fade base-modal", { show: _ctx.isDialogDisplay }]),
      style: _normalizeStyle({
        display: _ctx.isDialogDisplay ? 'block' : 'none',
        zIndex: _ctx.modalZIndex,
      }),
      tabindex: "-1",
      role: "dialog",
      "aria-modal": "true",
      onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onBackdropClick && _ctx.onBackdropClick(...args)), ["self"]))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["modal-dialog", _ctx.modalSizeClass]),
        style: _normalizeStyle(_ctx.modalStyle),
        role: "document"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-icon btn-active-color-primary",
              disabled: _ctx.isCloseDisabled,
              "aria-label": "Close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
            }, [
              _createElementVNode("span", _hoisted_5, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
              ])
            ], 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ]),
          (_ctx.showFooter && _ctx.$slots.footer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
              ]))
            : _createCommentVNode("", true)
        ])
      ], 6)
    ], 6)), [
      [_directive_dialog_auto_focus, _ctx.isDialogDisplay]
    ])
  ]))
}